import { showToast } from '../components';
import { getApiBasePath } from '../utils/amplify';
import { ApiCallback, request } from './api';
import { getValidAccessToken } from './strava';

export const savePushSubscription = async (subscription: PushSubscription, callback: ApiCallback) => {
  const token = await getValidAccessToken();
  if (!token) {
    showToast('Not logged in', 'warning');
    callback({ success: false, error: 'Not logged in' });
    return;
  }
  const apiBasePath = getApiBasePath();
  const path = `${apiBasePath}/push/subscribe/${token}`;
  request(path, callback, {
    subscription: subscription.toJSON(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });
};

export const deletePushSubscription = async (endpoint: string, callback: ApiCallback) => {
  const token = await getValidAccessToken();
  if (!token) {
    showToast('Not logged in', 'warning');
    callback({ success: false, error: 'Not logged in' });
    return;
  }
  const apiBasePath = getApiBasePath();
  const path = `${apiBasePath}/push/unsubscribe/${token}`;
  request(path, callback, { endpoint });
};

export const sendTestPush = async (callback: ApiCallback) => {
  const token = await getValidAccessToken();
  if (!token) {
    showToast('Not logged in', 'warning');
    callback({ success: false, error: 'Not logged in' });
    return;
  }
  const apiBasePath = getApiBasePath();
  const path = `${apiBasePath}/push/test/${token}`;
  request(path, callback, {});
};
